import React, { Component } from 'react';

export default class Options extends Component {
  render() {
    return (
      <table className="options">
        <thead>
          <tr>
            <th>Property</th>
            <th>Type</th>
            <th>Default</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>className</td>
            <td>string</td>
            <td>undefined</td>
            <td>Adds a given class to <code>.popupbox-wrapper</code>.</td>
          </tr>
          <tr>
            <td>style</td>
            <td>object</td>
            <td>{`{}`}</td>
            <td>Add custom CSS to <code>.popupbox-wrapper</code>.</td>
          </tr>
          <tr>
            <th colSpan="4" className="options-type">Transition</th>
          </tr>
          <tr>
            <td>overlayOpacity</td>
            <td>number</td>
            <td>0.75</td>
            <td>The opacity level of overlay. Avaliable range: 0 to 1.</td>
          </tr>
          <tr>
            <td>overlayClose</td>
            <td>boolean</td>
            <td>true</td>
            <td>If true, Popupbox will close when clicking overlay area.</td>
          </tr>
          <tr>
            <td>escClose</td>
            <td>boolean</td>
            <td>true</td>
            <td>If true, Popupbox will close when press esc key.</td>
          </tr>
          <tr>
            <td>fadeIn</td>
            <td>boolean</td>
            <td>false</td>
            <td>If true, Popupbox will open with fade-in transition.</td>
          </tr>
          <tr>
            <td>fadeInSpeed</td>
            <td>number</td>
            <td>500</td>
            <td>Sets the speed of the fade-in transition.</td>
          </tr>
          <tr>
            <td>fadeOut</td>
            <td>boolean</td>
            <td>true</td>
            <td>If true, Popupbox will close with fade-out transition.</td>
          </tr>
          <tr>
            <td>fadeOutSpeed</td>
            <td>number</td>
            <td>500</td>
            <td>Sets the speed of the fade-out transition.</td>
          </tr>

          <tr>
            <th colSpan="4" className="options-type">Title bar</th>
          </tr>
          <tr>
            <td>titleBar.enable</td>
            <td>boolean</td>
            <td>false</td>
            <td>If true, Popupbox will includes a title bar.</td>
          </tr>
          <tr>
            <td>titleBar.className</td>
            <td>string</td>
            <td>undefined</td>
            <td>Adds a given class to title bar.</td>
          </tr>
          <tr>
            <td>titleBar.text</td>
            <td>string</td>
            <td>undefined</td>
            <td>Defined the text of title bar.</td>
          </tr>
          <tr>
            <td>titleBar.closeButton</td>
            <td>boolean</td>
            <td>true</td>
            <td>If false, remove close button.</td>
          </tr>
          <tr>
            <td>titleBar.closeButtonClassName</td>
            <td>string</td>
            <td>undefined</td>
            <td>Adds a given class to close button.</td>
          </tr>
          <tr>
            <td>titleBar.closeText</td>
            <td>string</td>
            <td>✕</td>
            <td>Defined the text of close button.</td>
          </tr>
          <tr>
            <td>titleBar.position</td>
            <td>'top' or 'bottom'</td>
            <td>'top'</td>
            <td>Defined the relative position of title bar.</td>
          </tr>

          <tr>
            <th colSpan="4" className="options-type">Content</th>
          </tr>
          <tr>
            <td>content.className</td>
            <td>string</td>
            <td>undefined</td>
            <td>Adds a given class to <code>.popupbox-content</code>.</td>
          </tr>
          <tr>
            <td>content.style</td>
            <td>object</td>
            <td>{`{}`}</td>
            <td>Add custom CSS to <code>.popupbox-content</code>.</td>
          </tr>

          <tr>
            <th colSpan="4" className="options-type">Callback</th>
          </tr>
          <tr>
            <td>onOpen</td>
            <td>function</td>
            <td>undefined</td>
            <td>Callback that fires right before Popupbox begins to open.</td>
          </tr>
          <tr>
            <td>onComplete</td>
            <td>function</td>
            <td>undefined</td>
            <td>Callback that fires right after loaded content is displayed.</td>
          </tr>
          <tr>
            <td>onCleanup</td>
            <td>function</td>
            <td>undefined</td>
            <td>Callback that fires at the start of the close process.</td>
          </tr>
          <tr>
            <td>onClosed</td>
            <td>function</td>
            <td>undefined</td>
            <td>Callback that fires once Colorbox is closed.</td>
          </tr>
        </tbody>
      </table>
    )
  }
}



// WEBPACK FOOTER //
// ./components/options.js